type InterpolationFormat = (value: string, format?: string) => string;

interface I18OptionsShape {
    order: string[];
    lookupQuerystring: string;
    lookupCookie: string;
    lookupLocalStorage: string;
    lookupFromPathIndex: number;
    lookupFromSubdomainIndex: number;
    caches: string[];
    cookieMinutes: number;
    cookieOptions: { path: string };
    fallbackLng: string[];
    keySeparator: string;
    load: 'languageOnly';
    ns: string[];
    defaultNS: string;
    saveMissing: boolean;
    debug: boolean;
    interpolation: {
        escapeValue: boolean;
        formatSeparator: string;
        format: InterpolationFormat;
    };
    backend: {
        loadPath: string;
    };
}

export const I18N_OPTIONS: I18OptionsShape = {
    // order and from where user language should be detected
    order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],

    // keys or params to lookup language from
    lookupQuerystring: 'lang',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,

    // cache user language on
    caches: ['localStorage', 'cookie'],
    // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

    // optional expire and domain for set cookie
    cookieMinutes: 10,
    // cookieDomain: 'myDomain',

    // optional htmlTag with lang attribute, the default is:
    // htmlTag: document.documentElement,

    // only detect languages that are in the whitelist
    // checkWhitelist: true,

    // fallback to a similar whitelist language
    // Example 1: Browser language is 'es'
    // if 'es' is not found in whitelist, first fallback to any whitelist language that starts with 'es-', then fallback to fallbackLng ('es' -> 'es-*' -> fallbackLng)
    // Example 2: Browser language is 'es-MX'
    // if 'es-MX' is not found in whitelist, first fallback to 'es', then fallback to 'es-*', then fallback to fallbackLng ('es-MX' -> 'es' -> 'es-*' -> fallbackLng)
    // checkForSimilarInWhitelist: false,

    // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
    cookieOptions: { path: '/' },
    fallbackLng: ['en'],
    keySeparator: '::',
    load: 'languageOnly', // we only provide en, de -> no region specific locals like en-US, de-DE
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    saveMissing: true,
    debug: __isDev__,

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ',',
        format: (value: string, formatName?: string) => {
            if (formatName === 'uppercase') return value.toUpperCase();
            return value;
        },
    },
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        // crossDomain: true,
        // path to post missing resources
        // addPath: `${appSrc}/locales/{{lng}}/{{ns}}.missing.json`,
    },
};
